import { AxiosResponse } from 'axios';
import { useMutation, useQuery } from 'react-query';
import apiClient from '../apiClient/apiClient';
import { AddEditUserRequestBody, User } from './user.types';

/**
 *
 * @param enabled boolean
 * @param deleted filters by whether the user is deleted 
 * @returns User[]
 */
export const useUsers = (enabled: boolean = false, isDeleted: boolean = false) => {
    return useQuery<AxiosResponse<User[]>>({
        queryKey: ['users', isDeleted],
        queryFn: () => apiClient.get<User[]>('/users', { params: { isDeleted } }),
        enabled,
    });
};

export const useAddUser = () => {
    return useMutation((requestBody: AddEditUserRequestBody) => {
      return apiClient.post(`/users`, requestBody);
    });
  };

export const useUser = (requestBody: { loginId: string }, enabled: boolean = false) => {
  return useQuery<AxiosResponse<User>>({
    queryKey: ['user', requestBody.loginId],
    queryFn: () => apiClient.get<User>(`/users/${requestBody.loginId}`, { params: requestBody }),
    enabled,
  });
};

  export const useEditUser = (id: number | undefined) => {
    return useMutation((requestBody: AddEditUserRequestBody) => {
      return apiClient.put(`/users/${id}`, requestBody);
    });
  };